// store/useAlertStore.js
import {
  getLocalStorageItem,
  getUA,
  isIdentical,
  isObjectEmpty,
  saveStringify,
  setLocalStorageItem,
  validArray,
} from "data/functions";
import { v4 as uuidv4 } from "uuid";
import { create } from "zustand";
import { persist } from "zustand/middleware";

const useAlertStore = create(
  persist(
    (set, get) => ({
      // --- State ---
      alertArray: [],
      lastAlert: {},

      // --- Actions ---

      // Добавить уведомление
      setAlert: (value, parameter, secs = 3) => {
        const uuid = uuidv4();
        if (parameter === "warn") parameter = "warning";
        let timestamp = Date.now() + secs * 1000;
        const alert = {
          id: uuid,
          text: typeof value === "string" ? value : saveStringify(value),
          timestamp,
          type: parameter ?? "info",
        };

        set((state) => ({
          alertArray: [...state.alertArray, alert],
          lastAlert: alert,
        }));
      },

      // Очистить все уведомления
      clear: () => set({ alertArray: [] }),
    }),
    {
      name: "alert-storage",
      partialize: (state) => ({
        alertArray: [], // Сохраняем последние 3
        lastAlert: state.lastAlert,
      }),
    },
  ),
);

export default useAlertStore;
